import pdfMake, { userMark, setMyConfig, makeTableContent } from "../utils/pdf";

function pdfOrdenes(pContent) {
  const columns = [
    {
      key: "codigo",
      label: "Cód.",
      width: 28,
    },
    "fecha:wauto",
    "servicio:w*",
    {
      key: "horaSalida",
      label: "H. Salida",
      width: "auto",
    },
    "idioma:wauto",
    "registros:w30",
    {
      key: "nroAdultos",
      label: "PAX",
      width: 16,
    },
    {
      key: "nroNinos",
      label: "CHD",
      width: 16,
    },
    {
      key: "vehiculo",
      label: "Vehículo.",
      width: "*",
    },
    {
      key: "conductor",
      label: "Conductor.",
      width: "*",
    },
    {
      key: "contactoConductor",
      label: "Contacto.",
      width: "*",
    },
    {
      key: "guia",
      label: "Guía.",
      width: "*",
    },
    "asistente:w*",
    "transfer:w*",
    {
      key: "awanacancha",
      label: "Awan.",
      width: "auto",
    },
  ];

  const table = makeTableContent([...pContent.ordenes], columns);

  const columnsObservaciones = [
    {
      key: "codigo",
      label: "Código",
      width: 28,
    },
    {
      key: "observacion",
      label: "",
      width: "*",
    },
  ];

  const partObservaciones = pContent.resumen.observaciones.length
    ? [
        {
          text: "Observaciones",
          style: "header",
        },
        makeTableContent([...pContent.resumen.observaciones], columnsObservaciones),
        {
          text: "",
          margin: [0, 0, 0, 5],
        },
      ]
    : [];

  pdfMake
    .createPdf({
      info: {
        title: `Reporte de Órdenes`,
      },
      content: [
        {
          text: "Reporte de Órdenes",
          style: "header",
        },
        {
          columns: [
            {
              text: `Servicio: ${pContent.servicio}`,
              width: "auto",
            },
            {
              text: `Fecha: ${pContent.fecha}`,
              width: "auto",
            },
            {
              text: `Idioma: ${pContent.idioma}`,
              width: "auto",
            },
          ],
          margin: [0, 0, 0, 2.5],
        },
        {
          text: "Resumen",
          style: "header",
        },
        {
          columns: [
            {
              text: `Nro. de Órdenes: ${pContent.resumen.nroOrdenes}`,
              width: "auto",
            },
            {
              text: `Registros: ${pContent.resumen.registros}`,
              width: "auto",
            },
            {
              text: `P. Total: ${pContent.resumen.total}`,
              width: "auto",
            },
            {
              text: `PAX: ${pContent.resumen.PAX}`,
              width: "auto",
            },
            {
              text: `CHD: ${pContent.resumen.CHD}`,
              width: "auto",
            },
            {
              text: `Español: ${pContent.resumen.esp}`,
              width: "auto",
            },
            {
              text: `Inglés: ${pContent.resumen.ing}`,
              width: "auto",
            },
          ],
          margin: [0, 0, 0, 5],
        },
        table,
        ...partObservaciones,
        ...userMark(pContent.userMark, pContent.dateMark),
      ],
      ...setMyConfig(),
    })
    .print();
}

export default pdfOrdenes;
